const Cell = require('../BaseCell');
const _ = require('underscore');
const CC = require('CC');
const DateUtils = require('DateUtils');

export const CONSTANTS = {
    DATE_FORMATS: {
        TIMESTAMP: 'Timestamp',
        DATE: 'Date',
        DATE_TIME: 'DateTime:DateTime', // From DateTime to DateTime
        DATE_TIME_DATE: 'DateTime:Date', // From DateTime to Date
        DATA_DATE: 'DataDate',
        DATA_MONTH: 'DataMonth',
        TIMEZONE: 'TimeZone',
        TIMEZONE_DATE: 'TimeZone:Date',
        ISO_8601: 'ISO-8601'
    },
    DEFAULT_DATETIME_FORMAT: 'MMM DD, YYYY  HH:mm:ss'
};

/**
 * Displays a date
 * @param {Object} options
 * @returns column definition
 */
export const DateCell = function(options) {
    return {
        CellClass: Cell,
        options: _.extend(
            {
                width: '110px',
                className: 'dt-body-left text-left',
                sourceFormat: undefined,
                url: function(id, row) {
                    return id;
                },
                dateFormat: undefined,
                onGetData: function(data) {
                    let formatter;
                    let format = CC.configData.default_date_format_moment;
                    switch (this.sourceFormat) {
                        case CONSTANTS.DATE_FORMATS.DATE:
                            formatter = DateUtils.getFormattedDateFromDate;
                            break;
                        case CONSTANTS.DATE_FORMATS.TIMESTAMP:
                            formatter = DateUtils.getFormattedDateFromTimestamp;
                            break;
                        case CONSTANTS.DATE_FORMATS.DATE_TIME_DATE:
                            formatter = DateUtils.getFormattedDateFromDateTime;
                            break;
                        case CONSTANTS.DATE_FORMATS.DATE_TIME:
                            formatter = DateUtils.getFormattedDateTimeFromDateTime;
                            format = this.dateFormat || CONSTANTS.DEFAULT_DATETIME_FORMAT;
                            break;
                        case CONSTANTS.DATE_FORMATS.DATA_DATE:
                            formatter = DateUtils.getFormattedDateFromDataDate;
                            break;
                        case CONSTANTS.DATE_FORMATS.TIMEZONE:
                            formatter = DateUtils.getFormattedDateTimeFromDate;
                            break;
                        case CONSTANTS.DATE_FORMATS.TIMEZONE_DATE:
                            formatter = DateUtils.getFormattedDateFromISODateTime;
                            break;
                        case CONSTANTS.DATE_FORMATS.DATA_MONTH:
                            formatter = DateUtils.getFormattedMonthFromDataDate;
                            format = CC.configData.default_month_format_moment;
                            break;
                        case CONSTANTS.DATE_FORMATS.ISO_8601:
                            formatter = DateUtils.getFormattedDateFromISO8601Date;
                            format = this.dateFormat || CONSTANTS.DEFAULT_DATETIME_FORMAT;
                            break;
                        default:
                            throw new Error(`The sourceFormat is missing or invalid: '${this.sourceFormat}'`);
                    }
                    return formatter(data, null, format);
                },
                onDisplay: function(data, type, row, meta, translatedValue) {
                    return _.template(/* template */ `<div class="data-grid__cell--text"><%- data %><div>`)({
                        data: translatedValue || this.defaultContent
                    });
                },
                onExport: function(data, type, row, meta, translatedValue) {
                    return translatedValue;
                }
            },
            options
        )
    };
};
